import React, { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorMessages } from 'common/components';
import { Routes } from 'config/routes';
import { useTranslations } from 'contexts/LocalizationContext';
import { useCreateNews } from 'services/news';

import { ChildPageHeading } from '../../common/components/ChildPageHeading';
import NewsForm from './NewsForm';

const CreateNews = (): JSX.Element => {
  const translations = useTranslations();
  const navigate = useNavigate();
  const { mutate: createNews, isLoading, error } = useCreateNews();

  return (
    <>
      <ChildPageHeading>{translations('news_create')}</ChildPageHeading>
      <ErrorMessages errors={error} />
      <NewsForm
        isLoading={isLoading}
        onSubmit={(createNewsRequest) =>
          createNews(createNewsRequest, {
            onSuccess: () => navigate(Routes.NEWS_PATH),
          })
        }
      />
    </>
  );
};

export default CreateNews;
